import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import { Box, IconButton } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "../../contexts/ThemeContext";
import { Controller, useFormContext, useWatch } from "react-hook-form";

export default function ThemeButton({ color, defaultTheme, testId }) {
  const { t } = useTranslation();
  const { toggleTheme, mode, setTheme } = React.useContext(ThemeContext);

  const hasSetInitial = React.useRef(false);

  React.useEffect(() => {
    if (defaultTheme && !hasSetInitial.current) {
      setTheme(defaultTheme);
      hasSetInitial.current = true;
    }
  }, [defaultTheme, setTheme]);

  return (
    <IconButton onClick={toggleTheme} title={t("ToggleTheme")} data-testid={testId}>
      {mode === "dark" ? <LightModeIcon /> : <DarkModeIcon color={color} />}
    </IconButton>
  );
}

export function ThemeForm({ color, testId }) {
  const { t } = useTranslation();
  const { setTheme } = React.useContext(ThemeContext);
  const { control } = useFormContext();

  return (
    <Controller
      name="defaultTheme"
      control={control}
      render={({ field }) => {
        const isSelectedDark = field.value === "dark";
        return (
          <Box display="flex" alignItems="center" gap={1}>
            <IconButton
              onClick={() => {
                const nextTheme = isSelectedDark ? "light" : "dark";
                setTheme(nextTheme);
                field.onChange(nextTheme);
              }}
              title={t("ToggleTheme")}
              data-testid={testId}
            >
              {isSelectedDark ? (
                <DarkModeIcon />
              ) : (
                <LightModeIcon color={color} />
              )}
            </IconButton>
          </Box>
        );
      }}
    />
  );
}

export function MasterThemeButton({
  color = "inherit",
  defaultTheme = "light",
  testId
}) {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext();
  const currentTheme = useWatch({ control, name: "theme" }) || defaultTheme;

  const toggleTheme = () => {
    const nextTheme = currentTheme === "dark" ? "light" : "dark";
    setValue("theme", nextTheme);
  };

  return (
    <IconButton onClick={toggleTheme} title={t("ToggleTheme")} data-testid={testId}>
      {currentTheme === "dark" ? (
        <LightModeIcon color={color} />
      ) : (
        <DarkModeIcon color={color} />
      )}
    </IconButton>
  );
}
